/*
 * Unishop | Universal E-Commerce Template
 * Copyright 2018 rokaux
 * Theme Custom Scripts
 */

/* global jQuery, iziToast, noUiSlider, globalContent */

import { PhotoSwiper } from './main/PhotoSwiper.js';

/** Handles app specific navigation using the Owl Carousel. */
class OwlCarouselMgr {
  constructor($carousel, options) {
    if (!$carousel || !$carousel.length || $carousel.length == 0) {
      throw Error('Unassigned carousel parameter or no items in the carousel');
    }
    this.$carousel = $carousel;
    this.$carouselParent = this.$carousel.parent();
    this.$thumbnails = this.$carouselParent.find('.product-thumbnails');
    this.$thumbnailItems = this.$thumbnails.children('li');

    /* The Owl Carousel library has a bug in that the value of the URLhashListener option is not
     * respected (no code in the library checks the value). To work around this without making
     * changes to the library itself, we add code here instead. */
    this.useUrlNavigation = options.URLhashListener;
    if (!this.useUrlNavigation) {
      // Add click handlers instead of relying on the href attribute and link navigation:
      const anchors = this.$thumbnails.find('a');
      anchors.on('click', (e) => {
        const anchor = e.currentTarget;
        const $item = $(anchor).parent();

        /* This new code takes into account the case that there might be non-displayed thumbnails
         * which should not be counted when finding the index. See the ProductPreviewer class for
         * more on this. 7/11/2023. */
        const targetThumbnail = $item[0];
        let i = 0;
        let index = -1;
        this.$thumbnailItems.each((ndx, thumb) => {
          if (!thumb.classList.contains('d-none')) {
            if (thumb === targetThumbnail) {
              index = i;
            }
            i++;
          }
        });
        this.$carousel.trigger('to.owl.carousel', [index]);
      });
    }

    options.onTranslate = e => this.updateActiveItem(e);
    $carousel.owlCarousel(options);
  }

  /**
   * Updates the 'active' css class on thumbnail items and carousel items. Note this method used to
   * be named "activeHash".
   */
  updateActiveItem(e) {
    //console.log(`Reached updateActiveItem, type=${e.type}, target's classes: ${e.target.className}`);
    const hashKey = this.useUrlNavigation ? 'data-hash' : 'data-hiddenhash';
    const hrefAttr = this.useUrlNavigation ? 'href' : 'data-href';

    // 1. Get the hash of the carousel item:
    const i = e.item.index;
    const $owlItems = this.$carousel.find('.owl-item');
    const $activeOwlItem = $owlItems.eq(i);
    const $hashElement = $activeOwlItem.find(`[${hashKey}]`);
    const activeHash = $hashElement.attr(`${hashKey}`);

    if (this.$thumbnails.length) {
      // 2. Remove 'active' class from all product thumbnail items:
      this.$thumbnailItems.removeClass('active');

      // 3. Set 'active' class on the parent of the anchor element linking to the carousel item
      const $activeAnchor = this.$thumbnails.find(`[${hrefAttr}="#${activeHash}"]`);
      $activeAnchor.parent().addClass('active');
    }

    // 4. Remove 'active' class from all gallery items:
    const $allGalleryItems = this.$carousel.find('.gallery-item');
    $allGalleryItems.removeClass('active');

    // 5. Set 'active' class on the parent of all elements with a data-hash attribute equal to hash.
    // This parent should a the gallery item element.
    const $allActiveItems = this.$carousel.find(`[${hashKey}="${activeHash}"]`);
    $allActiveItems.parent().addClass('active');
  }
}

export class Unishop {
  constructor(options) {
    this.options = options || {};
    window.addEventListener('DOMContentLoaded', (event) => {
      this.setupOnDOMContentLoaded();
      setTimeout(() => this.setupDelayedFeatures(), 2000);
    });
  }

  setupOnDOMContentLoaded() {
    const self = this;

    if (this.options.useStickyNavBar) {
      // Check if Page Scrollbar is visible
      //------------------------------------------------------------------------------
      var hasScrollbar = function () {
        // The Modern solution
        if (typeof window.innerWidth === 'number') {
          return window.innerWidth > document.documentElement.clientWidth;
        }

        // rootElem for quirksmode
        var rootElem = document.documentElement || document.body;

        // Check overflow style property on body for fauxscrollbars
        var overflowStyle;

        if (typeof rootElem.currentStyle !== 'undefined') {
          overflowStyle = rootElem.currentStyle.overflow;
        }

        overflowStyle = overflowStyle || window.getComputedStyle(rootElem, '').overflow;

        // Also need to check the Y axis overflow
        var overflowYStyle;

        if (typeof rootElem.currentStyle !== 'undefined') {
          overflowYStyle = rootElem.currentStyle.overflowY;
        }

        overflowYStyle = overflowYStyle || window.getComputedStyle(rootElem, '').overflowY;

        var contentOverflows = rootElem.scrollHeight > rootElem.clientHeight;
        var overflowShown = /^(visible|auto)$/.test(overflowStyle) || /^(visible|auto)$/.test(overflowYStyle);
        var alwaysShowScroll = overflowStyle === 'scroll' || overflowYStyle === 'scroll';

        return (contentOverflows && overflowShown) || (alwaysShowScroll);
      };
      if (hasScrollbar()) {
        /* The only place we take advantage of the hasScrollbar class is while displaying popups, and
         * we have enabled the sticky navbar feature. When the popup is opened the <body> element's
         * scrollbar is removed, and to avoid the sticky navbar shifting to the right, its width is
         * reduced by the width of the scrollbar. Tor, 9/23/2021. */
        $('body').addClass('hasScrollbar');
      }
    }


    // Sticky Navbar
    //------------------------------------------------------------------------------
    if (this.options.useStickyNavBar) {
      function stickyHeader() {
        var $body = $('body');
        var $navbar = $('.navbar-sticky');
        var $topbarH = $('.topbar').outerHeight();
        if (typeof $topbarH === 'undefined') { // then Topbar is not used...
          $topbarH = 0;
        }
        var $navbarH = $navbar.outerHeight();
        if ($navbar.length) {
          $(window).on('scroll', function () {
            if ($(this).scrollTop() > $topbarH) {
              $navbar.addClass('navbar-stuck');
              if (!$navbar.hasClass('navbar-ghost')) {
                $body.css('padding-top', $navbarH);
              }
            } else {
              $navbar.removeClass('navbar-stuck');
              $body.css('padding-top', 0);
            }
          });
        }
      }
      stickyHeader();
    }


    // Language / Currency Switcher
    //---------------------------------------------------------
    this.setupLanguageCurrencySwitcher();

    // Off-Canvas Container
    //---------------------------------------------------------
    $('[data-toggle="offcanvas"]').on('click', self.offcanvasOpen);
    $('.site-backdrop').on('click', self.offcanvasClose);


    // Off-Canvas Menu
    //---------------------------------------------------------
    var menuInitHeight = $('.offcanvas-menu .menu').height();
    var backBtnText = globalContent.backBtnLabel;
    var subMenu = $('.offcanvas-menu .offcanvas-submenu');

    subMenu.each(function () {
      $(this).prepend('<li class="back-btn"><a href="#">' + backBtnText + '</a></li>');
    });

    var hasChildLink = $('.has-children .sub-menu-toggle');
    var backBtn = $('.offcanvas-menu .offcanvas-submenu .back-btn');

    backBtn.on('click', function (e) {
      var self = this,
        parent = $(self).parent(),
        siblingParent = $(self).parent().parent().siblings().parent(),
        menu = $(self).parents('.menu');

      parent.removeClass('in-view');
      siblingParent.removeClass('off-view');
      if (siblingParent.attr('class') === 'menu') {
        menu.css('height', menuInitHeight);
      } else {
        menu.css('height', siblingParent.height());
      }
      e.preventDefault();
    });

    hasChildLink.on('click', function (e) {
      var self = this,
        parent = $(self).parent().parent().parent(),
        menu = $(self).parents('.menu');

      parent.addClass('off-view');
      $(self).parent().parent().find('> .offcanvas-submenu').addClass('in-view');
      menu.css('height', $(self).parent().parent().find('> .offcanvas-submenu').height());

      e.preventDefault();
      return false;
    });


    if (this.options.useSmoothScrollToElement) {
      // Smooth scroll to element
      //---------------------------------------------------------
      /* If an anchor tag has the scroll-to class, then the code below will use the velocity library
       * to perform a smooth scroll to the target element. As of 9/23/2021 this feature is only used
       * on home-/landing-/meetus-pages with image sliders where the down-arrow button is enabled.
       * Hence, the useSmoothScrollToElement option should be set on these kinds of pages. */
      $(document).on('click', '.scroll-to', function (event) {
        var target = $(this).attr('href');
        if ('#' === target) {
          return false;
        }

        var $target = $(target);
        if ($target.length > 0) {
          var $elemOffsetTop = $target.data('offset-top') || 70;
          $('html').velocity('scroll', {
            offset: $(this.hash).offset().top - $elemOffsetTop,
            duration: 1000,
            easing: 'easeOutExpo',
            mobileHA: false
          });
        }
        event.preventDefault();
      });
    }


    // Isotope Grid / Filters (Gallery) - see https://isotope.metafizzy.co
    //------------------------------------------------------------------------------
    if (this.options.useIsotopeGrid) {
      // Used on the product category page. Tor, 9/23/2021.
      // Isotope Grid
      var isotopeGrid = $('.isotope-grid');
      if (isotopeGrid.length) {
        var $grid = isotopeGrid.imagesLoaded(function () {
          $grid.isotope({
            itemSelector: '.grid-item',
            transitionDuration: '0.7s',
            masonry: {
              columnWidth: '.grid-sizer',
              gutter: '.gutter-sizer'
            }
          });
        });
      }

      // Filtering
      if ($('.filter-grid').length > 0) {
        var $filterGrid = $('.filter-grid');
        $('.nav-pills').on('click', 'a', function (e) {
          e.preventDefault();
          $('.nav-pills a').removeClass('active');
          $(this).addClass('active');
          var $filterValue = $(this).attr('data-filter');
          $filterGrid.isotope({ filter: $filterValue });
        });
      }
    }


    // Gallery (Photoswipe)
    //------------------------------------------------------------------------------
    if (this.options.usePhotoSwiper) {
      this.acquirePhotoSwiper();
    }


    // Product Gallery
    //------------------------------------------------------------------------------
    if (this.options.useProductImageCarousel) {
      // Get an array of all elements with the product-carousel class set:
      var $productCarousel = $('.product-carousel');
      // Initialize an owl carousel for each element in the array:
      if ($productCarousel.length) {
        // Carousel init
        /*
        $productCarousel.owlCarousel({
          items: 1,
          loop: false,
          dots: false,
          URLhashListener: true,
          startPosition: 'URLHash',
          onTranslate: activeHash
        });
        */
        const options = {
          items: 1,
          loop: false,
          dots: false,
        };
        $productCarousel.each(function () {
          const mgr = new OwlCarouselMgr($(this), options);
        });
      }
    }


    //#region Disabled features:

    /* Search feature is currently not used on our site. Tor, 9/23/2021.
        // Site Search
        //---------------------------------------------------------
        function searchActions(openTrigger, closeTrigger, clearTrigger, target) {
          $(openTrigger).on('click', function () {
            $(target).addClass('search-visible');
            setTimeout(function () {
              $(target + ' > input').focus();
            }, 200);
          });
          $(closeTrigger).on('click', function () {
            $(target).removeClass('search-visible');
          });
          $(clearTrigger).on('click', function () {
            $(target + ' > input').val('');
            setTimeout(function () {
              $(target + ' > input').focus();
            }, 200);
          });
        }
        searchActions('.toolbar .tools .search', '.close-search', '.clear-search', '.site-search');
    */

    // Form Validation
    //------------------------------------------------------------------------------
    /* Tor, 7/18/19: We choose instead to do this manually for each form
    window.addEventListener('load', function() {
      // Fetch all the forms we want to apply custom Bootstrap validation styles to
      var forms = document.getElementsByClassName('needs-validation');
      // Loop over them and prevent submission
      var validation = Array.prototype.filter.call(forms, function(form) {
        form.addEventListener('submit', function(event) {
          if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
          }
          form.classList.add('was-validated');
        }, false);
      });
    }, false);
    */


    // Filter List Groups
    //---------------------------------------------------------
    /* I don't know anywhere this is used. Disabled for now. Tor, 9/23/2021.
        // var targetList = $();
        function filterList(trigger) {
          trigger.each(function () {
            var self = $(this);
            var target = self.data('filter-list');
            var search = self.find('input[type=text]');
            var filters = self.find('input[type=radio]');
            var list = $(target).find('.list-group-item');

            // Search
            search.keyup(function () {
              var searchQuery = search.val();
              list.each(function () {
                var text = $(this).text().toLowerCase();
                (text.indexOf(searchQuery.toLowerCase()) == 0) ? $(this).show() : $(this).hide();
              });
            });

            // Filters
            filters.on('click', function () {
              var targetItem = $(this).val();
              if (targetItem !== 'all') {
                list.hide();
                $('[data-filter-item=' + targetItem + ']').show();
              } else {
                list.show();
              }

            });
          });
        }
        filterList($('[data-filter-list]'));
    */

    // Countdown Function
    //------------------------------------------------------------------------------
    /* 9/3/2021, Tor: Countdown is currently not in use and has been commented out to reduce js download size.
        function countDownFunc(items, trigger) {
          items.each(function () {
            var countDown = $(this);
            var dateTime = $(this).data('date-time');

            var countDownTrigger = (trigger) ? trigger : countDown;
            countDownTrigger.downCount({
              date: dateTime,
              offset: +10
            });
          });
        }
        countDownFunc($('.countdown'));
    */

    // Toast Notifications
    //------------------------------------------------------------------------------
    /* I don't know anywhere this is used. Disabled for now. Tor, 9/23/2021.
        $('[data-toast]').on('click', function () {
          var self = $(this);
          var $type = self.data('toast-type');
          var $icon = self.data('toast-icon');
          var $position = self.data('toast-position');
          var $title = self.data('toast-title');
          var $message = self.data('toast-message');
          var toastOptions = '';

          switch ($position) {
            case 'topRight':
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'topRight',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
              break;
            case 'bottomRight':
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'bottomRight',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
              break;
            case 'topLeft':
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'topLeft',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInRight',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
              break;
            case 'bottomLeft':
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'bottomLeft',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInRight',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
              break;
            case 'topCenter':
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'topCenter',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInDown',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
              break;
            case 'bottomCenter':
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'bottomCenter',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInUp',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
              break;
            default:
              toastOptions = {
                class: 'iziToast-' + $type || '',
                title: $title || 'Title',
                message: $message || 'toast message',
                animateInside: false,
                position: 'topRight',
                progressBar: false,
                icon: $icon,
                timeout: 3200,
                transitionIn: 'fadeInLeft',
                transitionOut: 'fadeOut',
                transitionInMobile: 'fadeIn',
                transitionOutMobile: 'fadeOut'
              };
          }

          iziToast.show(toastOptions);
        });

        // Launch default BS Toasts on click       // Added v3.1
        $('[data-toggle="toast"]').on('click', function () {
          var target = '#' + $(this).data('toast-id');
          $(target).toast('show');
        });
    */

    // Wishlist Button
    //------------------------------------------------------------------------------
    /* Not currently used. Disabled for now. Tor, 9/23/2021.
        $('.btn-wishlist').on('click', function () {
          var iteration = $(this).data('iteration') || 1;
          var toastOptions = {
            title: globalContent.wishListPopupTitle,
            animateInside: false,
            position: 'topRight',
            progressBar: false,
            timeout: 3200,
            transitionIn: 'fadeInLeft',
            transitionOut: 'fadeOut',
            transitionInMobile: 'fadeIn',
            transitionOutMobile: 'fadeOut'
          };

          switch (iteration) {
            case 1:
              $(this).addClass('active');
              toastOptions.class = 'iziToast-info';
              toastOptions.message = globalContent.wishListPopupContentAdded;
              toastOptions.icon = 'icon-bell';
              break;

            case 2:
              $(this).removeClass('active');
              toastOptions.class = 'iziToast-danger';
              toastOptions.message = globalContent.wishListPopupContentRemoved;
              toastOptions.icon = 'icon-ban';
              break;
          }

          iziToast.show(toastOptions);

          iteration++;
          if (iteration > 2) iteration = 1;
          $(this).data('iteration', iteration);
        });
    */

    // Shop Categories Widget
    //------------------------------------------------------------------------------
    /* Disabled for now. Tor, 9/23/2021.
        // Used on the product category page if we enable sidebar filtering
        var categoryToggle = $('.widget-categories .has-children > a');

        function closeCategorySubmenu() {
          categoryToggle.parent().removeClass('expanded');
        }
        categoryToggle.on('click', function (e) {
          if ($(e.target).parent().is('.expanded')) {
            closeCategorySubmenu();
          } else {
            closeCategorySubmenu();
            $(this).parent().addClass('expanded');
          }
        });
    */


    // Range Slider
    //------------------------------------------------------------------------------
    /* 9/3/2021, Tor: ui-range-slider/noUiSlider is currently not in use and has been commented out to reduce js download size.
        var rangeSlider = document.querySelector('.ui-range-slider');
        if (typeof rangeSlider !== 'undefined' && rangeSlider !== null) {
          var dataStartMin = parseInt(rangeSlider.parentNode.getAttribute('data-start-min'), 10);
          var dataStartMax = parseInt(rangeSlider.parentNode.getAttribute('data-start-max'), 10);
          var dataMin = parseInt(rangeSlider.parentNode.getAttribute('data-min'), 10);
          var dataMax = parseInt(rangeSlider.parentNode.getAttribute('data-max'), 10);
          var dataStep = parseInt(rangeSlider.parentNode.getAttribute('data-step'), 10);
          var valueMin = document.querySelector('.ui-range-value-min span');
          var valueMax = document.querySelector('.ui-range-value-max span');
          var valueMinInput = document.querySelector('.ui-range-value-min input');
          var valueMaxInput = document.querySelector('.ui-range-value-max input');
          noUiSlider.create(rangeSlider, {
            start: [dataStartMin, dataStartMax],
            connect: true,
            step: dataStep,
            range: {
              'min': dataMin,
              'max': dataMax
            }
          });
          rangeSlider.noUiSlider.on('update', function (values, handle) {
            var value = values[handle];
            if (handle) {
              valueMax.innerHTML = Math.round(value);
              valueMaxInput.value = Math.round(value);
            } else {
              valueMin.innerHTML = Math.round(value);
              valueMinInput.value = Math.round(value);
            }
          });
        }
    */


    // Interactive Credit Card
    //------------------------------------------------------------------------------
    /* Not currently used. Disabled for now. Tor, 9/23/2021.
        // The card library is created by Jesse Pollak and can be found here: https://github.com/jessepollak/card.
        var $creditCard = $('.interactive-credit-card');
        if ($creditCard.length) {
          $creditCard.card({
            form: '.interactive-credit-card',
            container: '.card-wrapper'
          });
        }
    */

    // Google Maps API
    //------------------------------------------------------------------------------
    /* 9/3/2021, Tor: google-map/gmap3 is currently not in use and has been commented out to reduce js download size.
    var $googleMap = $('.google-map');
    if ($googleMap.length) {
      $googleMap.each(function () {
        var mapHeight = $(this).data('height'),
          address = $(this).data('address'),
          zoom = $(this).data('zoom'),
          controls = $(this).data('disable-controls'),
          scrollwheel = $(this).data('scrollwheel'),
          marker = $(this).data('marker'),
          markerTitle = $(this).data('marker-title'),
          styles = $(this).data('styles');
        $(this).height(mapHeight);
        $(this).gmap3({
          marker: {
            address: address,
            data: markerTitle,
            options: {
              icon: marker
            },
            events: {
              mouseover: function (marker, event, context) {
                var map = $(this).gmap3('get'),
                  infowindow = $(this).gmap3({ get: { name: 'infowindow' } });
                if (infowindow) {
                  infowindow.open(map, marker);
                  infowindow.setContent(context.data);
                } else {
                  $(this).gmap3({
                    infowindow: {
                      anchor: marker,
                      options: { content: context.data }
                    }
                  });
                }
              },
              mouseout: function () {
                var infowindow = $(this).gmap3({ get: { name: 'infowindow' } });
                if (infowindow) {
                  infowindow.close();
                }
              }
            }
          },
          map: {
            options: {
              zoom: zoom,
              disableDefaultUI: controls,
              scrollwheel: scrollwheel,
              styles: styles
            }
          }
        });
      });
    }
    */

    //#endregion

  } // End of setup function

  setupDelayedFeatures() {
    // Disable default link behavior for dummy links that have href='#'
    //------------------------------------------------------------------------------
    var $emptyLink = $('a[href="#"]');
    $emptyLink.on('click', function (e) {
      /* Normally, when you click on a link with href="#", the # will be appended to the url.
       * Calling preventDefault() stops this default behavior. Tor, 9/23/2021 */
      e.preventDefault();
    });


    // Animated Scroll to Top Button
    //------------------------------------------------------------------------------
    var $scrollTop = $('.scroll-btn.to-top');
    if ($scrollTop.length > 0) {
      $(window).on('scroll', function () {
        if ($(this).scrollTop() > 600) {
          $scrollTop.addClass('visible');
        } else {
          $scrollTop.removeClass('visible');
        }
      });
      $scrollTop.on('click', function (e) {
        e.preventDefault();
        $('html').velocity('scroll', {
          offset: 0,
          duration: 1200,
          easing: 'easeOutExpo',
          mobileHA: false
        });
      });
    }


    // Tooltips
    //------------------------------------------------------------------------------
    $('[data-toggle="tooltip"]').tooltip();


    // Popovers
    //------------------------------------------------------------------------------
    $('[data-toggle="popover"]').popover();



  }

  acquirePhotoSwiper() {
    // The swiper will add click event handlers to all wrapper and capable elements in the DOM.
    // The event handlers will display the associated image(s) in a fullscreen viewer and allow
    // browsing the images. Tor, 9/23/2021.
    if (!this.photoSwiper) {
      /* Note, we're passing a script load promise to the PhotoSwiper to allow it to wait for the
       * script (containing the PhotoSwipe library) to load before using it. */
      this.photoSwiper = new PhotoSwiper('.gallery-wrapper', '.fullscreen-capable', this.options.vendorDelayedWaiter.promise);
    }
    return this.photoSwiper;
  }

  getPhotoSwiper() {
    return this.acquirePhotoSwiper();
  }

  offcanvasOpen(e) {
    var $body = $('body');
    var targetEl = $(e.target).attr('href');
    $(targetEl).addClass('active');
    $body.css('overflow', 'hidden');
    $body.addClass('offcanvas-open');
    e.preventDefault();
  }

  offcanvasClose() {
    var $body = $('body');
    $body.removeClass('offcanvas-open');
    setTimeout(function() {
      $body.css('overflow', 'visible');
      $('.offcanvas-container').removeClass('active');
    }, 450);
  }

  setupLanguageCurrencySwitcher() {
    function hideMenu() {
      // Hide menu:
      $('.lang-currency-switcher-wrap').removeClass('show');
      $('.lang-currency-switcher-wrap .dropdown-menu').removeClass('show');
      // Remove global click handler:
      $(document).off('click', handleGlobalClickEvent);
    }

    function handleGlobalClickEvent(event) {
      if ($(event.target).closest('.lang-currency-switcher-wrap a.active').length) {
        // We clicked the menu item for the active language...
        event.preventDefault();
        hideMenu();
      } else if (!$(event.target).closest('.lang-currency-switcher-wrap').length) {
        // We clicked outside the menu...
        hideMenu();
      } else {
        // We either clicked the menu toggle, or the menu item for another language
        // Do nothing, we might be navigating to another page
      }
    }

    function showMenu($menuToggle) {
      // Show menu:
      $menuToggle.parent().addClass('show');
      $menuToggle.parent().find('.dropdown-menu').addClass('show');
      // Add global click handler:
      $(document).on('click', handleGlobalClickEvent);
    }

    $('.lang-currency-switcher').on('click', function () {
      // Language menu switcher clicked
      if ($(event.target).closest('.lang-currency-switcher-wrap.show').length) {
        hideMenu(); // Menu was already visible, let's hide it
      } else {
        showMenu($(this));
      }
    });
  }
}
